module.exports = __webpack_public_path__ + "img/istra-vacation-projekt-bg.a214360a.png";